import LTR from "@brand-icons/global/fire/fire-ltr.svg";

import { iconFactory } from "../iconFactory";

export const FireIcon = iconFactory("FireIcon", LTR);
